"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Terminal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _xterm = require("xterm");

var _xtermAddonFit = require("xterm-addon-fit");

var _DqLoading = _interopRequireDefault(require("../../common/feedback/DqLoading/DqLoading"));

var _DqAlertDialog = _interopRequireDefault(require("../../common/feedback/dialog/DqAlertDialog"));

var _ResizeSensor = _interopRequireDefault(require("../../common/ResizeSensor/ResizeSensor"));

var _terminalSocket = require("./terminal-socket");

var _terminalHelpers = require("./terminal-helpers");

require("xterm/css/xterm.css");

var _terminalTermjs = _interopRequireDefault(require("./terminal-termjs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const NEXT_GEN_PATH = "jupyter-enterprise-gateway";
const initialState = {
  isConnected: false,
  isNextGen: false,
  resetPrompt: false
};

class Terminal extends _react.Component {
  constructor(props, context) {
    super(props, context);

    _defineProperty(this, "codeRunnerReadyForSocket", () => !this.state.isConnected && this.props.connection_info && this.context.socket === null);

    _defineProperty(this, "codeRunnerRequiresDisconnect", () => this.props.connection_info === null && this.context.socket !== null);

    _defineProperty(this, "connectedToWrongCodeRunner", () => this.state.isConnected && this.props.connection_info && this.props.connection_info.mission_id !== this.props.currentLessonId);

    _defineProperty(this, "initializeTerminal", () => {
      this.xterm = new _xterm.Terminal({
        cursorBlink: true,
        fontFamily: "source-code-pro,monospace",
        lineHeight: "1",
        rendererType: "dom"
      });
      this.fitAddon = new _xtermAddonFit.FitAddon();
      this.xterm.loadAddon(this.fitAddon);
      this.xterm.open(this.container);
      this.fitAddon.fit(); // When a student types into the terminal, send this data over the socket

      this.xterm.onData(data => {
        if (this.context.socket) this.context.socket.emit(_terminalTermjs.default.events.data, data);
      }); // When the terminal resizes, resize the remote terminal

      this.xterm.onResize(this.resizeTerminal);
    });

    _defineProperty(this, "resetTerminal", () => {
      // This needs to go first so that we reset connection info
      if (this.props.reset_terminal) this.props.reset_terminal(this.props.current_step_index);
      this.xterm.dispose();
      this.fitAddon = null;
      this.destroySocket();
      this.initializeTerminal();
      this.setState(initialState);
    });

    _defineProperty(this, "resetPrompt", () => {
      this.setState({
        resetPrompt: true
      });
    });

    _defineProperty(this, "resizeTerminal", size => {
      if (this.state.isNextGen && this.context.socket) this.context.socket.emit(_terminalTermjs.default.events.resize, size);else if (this.props.resize) this.props.resize(size);
    });

    _defineProperty(this, "connectSocket", () => {
      var _this$props$connectio, _this$props$connectio2;

      // Do not re-connect if socket already connected or is connecting
      if (this.connecting || this.context.socket) return; // Set connecting status to avoid concurrect connection requests

      this.connecting = true; // Connect to socket and obtain direct reference

      const socket = this.context.connect(this.props.connection_info);
      if (!socket) return; // Get is next gen status from connection info

      const isNextGen = ((_this$props$connectio = this.props.connection_info) === null || _this$props$connectio === void 0 ? void 0 : (_this$props$connectio2 = _this$props$connectio.path) === null || _this$props$connectio2 === void 0 ? void 0 : _this$props$connectio2.indexOf(NEXT_GEN_PATH)) !== -1;
      /**
       * When socket connects:
       * 1) Update internal state
       * 2) Focus xterm terminal
       * 3) Resize terminal to fit current window
       */

      socket.on("connect", () => {
        this.setState({
          isConnected: true,
          isNextGen
        }); // This ensures that a student is always greeted with a prompt
        // If we don't do this, the terminal appears blank until the student
        // creates input

        this.emitClear();
        this.xterm.focus(); // Resize the remote terminal to match the current size

        this.resizeTerminal({
          cols: this.xterm.cols,
          rows: this.xterm.rows
        });
      });
      socket.on("reconnect_failed", () => {
        this.resetPrompt();
      });
      socket.on("disconnect", () => {
        this.destroySocket();
      });
      /**
       * When the socket receives data from the backend,
       * 1) Write the output to the UI
       * 2) Perform answer checking
       */

      socket.on(_terminalTermjs.default.events.data_push, data => {
        if ((0, _isEmpty.default)(data)) {
          return;
        } // We're passing answer checking as a callback for the write method
        // Otherwise xterm buffer doesn't have all data available at the moment of answer checking


        this.xterm.write(data, () => this.doAnswerChecking(data));
      }); // Clear connecting state

      this.connecting = false;
    });

    _defineProperty(this, "destroySocket", () => {
      if (this.context.socket === null) return; // Removes all listeners and disconnects

      this.context.disconnect();
      this.setIsConnected(false);
    });

    _defineProperty(this, "setIsConnected", connected => {
      this.setState({
        isConnected: connected
      });
    });

    _defineProperty(this, "emitClear", () => {
      if (this.context.socket) {
        this.context.socket.emit(_terminalTermjs.default.events.data, "clear\n");
      }
    });

    _defineProperty(this, "doAnswerChecking", data => {
      if (!this.props.check_answer) return; // If user already got success answer do not perform answer check

      if (this.props.answer_check.success) {
        return;
      } // To avoid performing answer checking on command output,
      // check if socket returns prompt


      if (!(0, _terminalHelpers.endsWithUserPrompt)(data)) {
        return;
      }

      const lines = (0, _terminalHelpers.getTerminalLines)(this.xterm.buffer);
      const infoForAnswerChecking = (0, _terminalHelpers.getInfoForAnswerChecking)(lines);

      if (infoForAnswerChecking === "") {
        return;
      }

      this.props.check_answer(infoForAnswerChecking, this.props.current_step_index);
    });

    _defineProperty(this, "stepChanged", prevProps => {
      const diff = this.props.current_step_index - prevProps.current_step_index;

      if (diff > 0) {
        return 1;
      }

      if (diff < 0) {
        return -1;
      }

      return 0;
    });

    _defineProperty(this, "onResize", () => {
      this.fitAddon.fit();
    });

    _defineProperty(this, "renderLoadingMessage", () => {
      const {
        isConnected
      } = this.state;
      const {
        behindPaywall
      } = this.props;
      return (!isConnected || behindPaywall) && /*#__PURE__*/_react.default.createElement(_DqLoading.default, {
        fullScreen: true,
        message: "Initializing the command line terminal",
        className: "dq-z-10 dq-bg-opacity-100"
      });
    });

    this.container = /*#__PURE__*/(0, _react.createRef)();
    this.xterm = null;
    this.fitAddon = null;
    this.state = initialState;
  }

  componentDidMount() {
    this.initializeTerminal();
    if (this.codeRunnerReadyForSocket()) this.connectSocket();
  }

  componentDidUpdate(prevProps, _prevState, _snapshot) {
    if (this.codeRunnerReadyForSocket()) {
      this.connectSocket();
    }

    if (this.codeRunnerRequiresDisconnect()) {
      this.resetTerminal();
    }

    if ((prevProps.connection_info !== this.props.connection_info || prevProps.currentLessonId !== this.props.currentLessonId) && this.connectedToWrongCodeRunner()) {
      this.resetPrompt();
    }

    const stepChange = this.stepChanged(prevProps);

    if (stepChange > 0) {
      if (this.props.resetAnswerChecking) this.props.resetAnswerChecking();
    }
  }

  componentWillUnmount() {
    this.xterm.dispose();
    this.destroySocket();
  }
  /**
   *
   * @returns {boolean}
   */


  render() {
    const {
      resetPrompt
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "dq-h-full dq-w-full dq-bg-black dq-p-2"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dq-h-full",
      ref: ref => {
        this.container = ref;
        return this.container;
      }
    }), this.renderLoadingMessage(), /*#__PURE__*/_react.default.createElement(_ResizeSensor.default, {
      debounce: true,
      onResize: this.onResize
    }), resetPrompt && /*#__PURE__*/_react.default.createElement(_DqAlertDialog.default, {
      title: "Network Issues",
      message: "Something with the network went wrong, please try again",
      actionsConfirmText: "Reconnect",
      handleOnConfirm: this.resetTerminal
    }));
  }

}

exports.Terminal = Terminal;

_defineProperty(Terminal, "contextType", _terminalSocket.SocketContext);

const propTypes = {
  // steps
  current_step_index: _propTypes.default.number.isRequired,
  // lesson
  currentLessonId: _propTypes.default.string.isRequired,
  behindPaywall: _propTypes.default.bool.isRequired,
  // socket
  connection_info: _propTypes.default.shape({
    mission_id: _propTypes.default.string,
    path: _propTypes.default.string,
    port: _propTypes.default.string,
    token: _propTypes.default.string,
    username: _propTypes.default.string,
    ip: _propTypes.default.string
  }).isRequired,
  answer_check: _propTypes.default.shape({
    success: _propTypes.default.bool.isRequired
  }),
  check_answer: _propTypes.default.func,
  reset_terminal: _propTypes.default.func,
  resetAnswerChecking: _propTypes.default.func,
  // this is the resize function for legacy runners (which proxies through
  // the backend). This can be removed once we migrate all CLI lessons to
  // next gen.
  resize: _propTypes.default.func
};
const defaultProps = {
  answer_check: undefined,
  check_answer: undefined,
  reset_terminal: undefined,
  resetAnswerChecking: undefined,
  resize: undefined
};
Terminal.propTypes = propTypes;
Terminal.defaultProps = defaultProps;

const TerminalWithSocket = ({ ...args
}) => /*#__PURE__*/_react.default.createElement(_terminalSocket.SocketProvider, null, /*#__PURE__*/_react.default.createElement(Terminal, args));

TerminalWithSocket.propTypes = propTypes;
TerminalWithSocket.defaultProps = defaultProps;
var _default = TerminalWithSocket;
exports.default = _default;